/// <amd-module name="VSSUI/Components/Header/HeaderDescription" />
import * as React from "react";

import { IHeaderDescriptionProps } from "./Header.Props";

import { css, getSafeId } from "VSSUI/Util";

export class HeaderDescription extends React.Component<IHeaderDescriptionProps> {
    public render() {
        return (
            <div className={css(this.props.className, "bolt-header-description body-m secondary-text")} id={getSafeId(this.props.id)}>
                {this.props.children}
            </div>
        );
    }
}
